const FooterLogo = () => (
    <svg
        width='132'
        height='37'
        viewBox='0 0 132 37'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='footer-logo'
    >
        <path
            d='M15.8531 35.9901L21.3606 33.0021C21.5365 32.9069 21.6836 32.7658 21.7859 32.5939C21.8883 32.4219 21.9423 32.2255 21.9422 32.0254V1.64635C21.9423 1.52785 21.9108 1.41145 21.851 1.30918C21.7911 1.2069 21.7051 1.12245 21.6017 1.06454C21.4983 1.00662 21.3813 0.97734 21.2628 0.979718C21.1444 0.982096 21.0287 1.01605 20.9277 1.07806L15.4002 4.4545C15.238 4.55379 15.1039 4.69311 15.011 4.8591C14.9181 5.02509 14.8694 5.21217 14.8696 5.40238V35.4063C14.8699 35.5215 14.9001 35.6347 14.9573 35.7348C15.0144 35.8349 15.0965 35.9185 15.1956 35.9773C15.2947 36.0361 15.4074 36.0683 15.5226 36.0705C15.6379 36.0727 15.7518 36.045 15.8531 35.9901Z'
            fill='url(#paint0_linear_3794_18081)'
        />
        <path
            d='M11.9924 27.8296V34.4893C11.9924 34.5672 11.9718 34.6437 11.9328 34.7111C11.8938 34.7785 11.8378 34.8345 11.7703 34.8734C11.7028 34.9124 11.6263 34.9328 11.5484 34.9328C11.4705 34.9328 11.3939 34.9123 11.3265 34.8733L7.53496 32.6645L1.57234 29.1816C1.23554 28.9871 0.955711 28.7076 0.760915 28.371C0.56612 28.0344 0.463191 27.6525 0.462402 27.2636V13.1096C0.462691 12.9099 0.516883 12.7139 0.619246 12.5424C0.72161 12.3709 0.868376 12.2302 1.04404 12.1351L6.55152 9.14492C6.653 9.08989 6.76707 9.06219 6.88249 9.06453C6.99791 9.06687 7.11072 9.09918 7.20989 9.15828C7.30906 9.21737 7.39116 9.30124 7.44814 9.40164C7.50512 9.50204 7.53507 9.61552 7.53496 9.73097V23.3189C7.53536 23.7081 7.63812 24.0905 7.83293 24.4275C8.02775 24.7645 8.30777 25.0444 8.6449 25.239L11.4486 26.8707C11.6149 26.9693 11.7526 27.1096 11.848 27.2779C11.9434 27.4461 11.9932 27.6363 11.9924 27.8296Z'
            fill='url(#paint1_linear_3794_18081)'
        />
        <path
            d='M11.3265 34.8667L7.53496 32.6579L1.57234 29.1816C1.23554 28.9871 0.955711 28.7076 0.760915 28.371C0.56612 28.0344 0.463191 27.6525 0.462402 27.2636V13.1096C0.462691 12.9099 0.516883 12.7139 0.619246 12.5424C0.72161 12.3709 0.868376 12.2302 1.04404 12.1351L6.55152 9.14492C6.653 9.08989 6.76707 9.06219 6.88249 9.06453C6.99791 9.06687 7.11072 9.09918 7.20989 9.15828C7.30906 9.21737 7.39116 9.30124 7.44814 9.40164C7.50512 9.50204 7.53507 9.61552 7.53496 9.73097V23.3189C7.53496 23.3189 7.09539 27.803 11.3265 34.8667Z'
            fill='url(#paint2_radial_3794_18081)'
        />
        <path
            d='M15.8531 35.9901L21.3606 33.0021C21.5365 32.9069 21.6836 32.7658 21.7859 32.5939C21.8883 32.4219 21.9423 32.2255 21.9422 32.0254V1.64635C21.9423 1.52785 21.9108 1.41145 21.851 1.30918C21.7911 1.2069 21.7051 1.12245 21.6017 1.06454C21.4983 1.00662 21.3813 0.97734 21.2628 0.979718C21.1444 0.982096 21.0287 1.01605 20.9277 1.07806L15.4002 4.4545C15.238 4.55379 15.1039 4.69311 15.011 4.8591C14.9181 5.02509 14.8694 5.21217 14.8696 5.40238V35.4063C14.8699 35.5215 14.9001 35.6347 14.9573 35.7348C15.0144 35.8349 15.0965 35.9185 15.1956 35.9773C15.2947 36.0361 15.4074 36.0683 15.5226 36.0705C15.6379 36.0727 15.7518 36.045 15.8531 35.9901Z'
            fill='url(#paint3_linear_3794_18081)'
        />
        <path
            d='M11.9924 27.8296V34.4893C11.9924 34.5672 11.9718 34.6437 11.9328 34.7111C11.8938 34.7785 11.8378 34.8345 11.7703 34.8734C11.7028 34.9124 11.6263 34.9328 11.5484 34.9328C11.4705 34.9328 11.3939 34.9123 11.3265 34.8733L7.53496 32.6645L1.57234 29.1816C1.23554 28.9871 0.955711 28.7076 0.760915 28.371C0.56612 28.0344 0.463191 27.6525 0.462402 27.2636V13.1096C0.462691 12.9099 0.516883 12.7139 0.619246 12.5424C0.72161 12.3709 0.868376 12.2302 1.04404 12.1351L6.55152 9.14492C6.653 9.08989 6.76707 9.06219 6.88249 9.06453C6.99791 9.06687 7.11072 9.09918 7.20989 9.15828C7.30906 9.21737 7.39116 9.30124 7.44814 9.40164C7.50512 9.50204 7.53507 9.61552 7.53496 9.73097V23.3189C7.53536 23.7081 7.63812 24.0905 7.83293 24.4275C8.02775 24.7645 8.30777 25.0444 8.6449 25.239L11.4486 26.8707C11.6149 26.9693 11.7526 27.1096 11.848 27.2779C11.9434 27.4461 11.9932 27.6363 11.9924 27.8296Z'
            fill='url(#paint4_linear_3794_18081)'
        />
        <path
            d='M11.3265 34.8667L7.53496 32.6579L1.57234 29.1816C1.23554 28.9871 0.955711 28.7076 0.760915 28.371C0.56612 28.0344 0.463191 27.6525 0.462402 27.2636V13.1096C0.462691 12.9099 0.516883 12.7139 0.619246 12.5424C0.72161 12.3709 0.868376 12.2302 1.04404 12.1351L6.55152 9.14492C6.653 9.08989 6.76707 9.06219 6.88249 9.06453C6.99791 9.06687 7.11072 9.09918 7.20989 9.15828C7.30906 9.21737 7.39116 9.30124 7.44814 9.40164C7.50512 9.50204 7.53507 9.61552 7.53496 9.73097V23.3189C7.53496 23.3189 7.09539 27.803 11.3265 34.8667Z'
            fill='url(#paint5_radial_3794_18081)'
        />
        <path
            opacity='0.3'
            d='M15.5353 36.183C15.3292 36.183 15.1316 36.1011 14.9859 35.9554C14.8402 35.8097 14.7583 35.6121 14.7583 35.406V5.40213C14.7588 5.19292 14.8128 4.98731 14.9149 4.80474C15.0171 4.62217 15.1641 4.46868 15.3422 4.35879L20.8696 0.98235C20.9918 0.909301 21.1313 0.87022 21.2737 0.869141C21.4799 0.86914 21.6778 0.950924 21.8239 1.09657C21.9699 1.24221 22.0523 1.43983 22.0528 1.6461V32.0252C22.0525 32.2451 21.993 32.461 21.8805 32.65C21.768 32.8391 21.6067 32.9944 21.4135 33.0996L15.906 36.0875C15.7927 36.1506 15.665 36.1834 15.5353 36.183Z'
            fill='url(#paint6_linear_3794_18081)'
        />
        <path
            d='M15.8531 35.9901L21.3606 33.0021C21.5365 32.9069 21.6836 32.7658 21.7859 32.5939C21.8883 32.4219 21.9423 32.2255 21.9422 32.0254V1.64635C21.9423 1.52785 21.9108 1.41145 21.851 1.30918C21.7911 1.2069 21.7051 1.12245 21.6017 1.06454C21.4983 1.00662 21.3813 0.97734 21.2628 0.979718C21.1444 0.982096 21.0287 1.01605 20.9277 1.07806L15.4002 4.4545C15.238 4.55379 15.1039 4.69311 15.011 4.8591C14.9181 5.02509 14.8694 5.21217 14.8696 5.40238V35.4063C14.8699 35.5215 14.9001 35.6347 14.9573 35.7348C15.0144 35.8349 15.0965 35.9185 15.1956 35.9773C15.2947 36.0361 15.4074 36.0683 15.5226 36.0705C15.6379 36.0727 15.7518 36.045 15.8531 35.9901Z'
            fill='url(#paint7_linear_3794_18081)'
        />
        <path
            opacity='0.3'
            d='M11.548 35.0464C11.4505 35.0459 11.3548 35.0198 11.2705 34.9709L1.50301 29.288C1.15094 29.0822 0.858803 28.7879 0.655542 28.4343C0.452282 28.0808 0.344969 27.6802 0.344239 27.2724V13.1096C0.343996 12.8898 0.403308 12.674 0.515879 12.4852C0.62845 12.2964 0.790102 12.1417 0.983593 12.0374L6.49107 9.04719C6.60939 8.98221 6.74263 8.94926 6.8776 8.95163C7.01257 8.95399 7.14458 8.99158 7.26055 9.06067C7.37652 9.12976 7.47246 9.22794 7.53879 9.3455C7.60513 9.46307 7.6396 9.59592 7.63879 9.73091V23.3188C7.63945 23.6875 7.73649 24.0497 7.92028 24.3694C8.10407 24.6891 8.36822 24.9552 8.68656 25.1413L11.4902 26.7751C11.6746 26.8826 11.8276 27.0365 11.9339 27.2215C12.0402 27.4065 12.0962 27.6162 12.0963 27.8296V34.4892C12.0969 34.6356 12.0396 34.7764 11.9369 34.8807C11.8342 34.9851 11.6944 35.0447 11.548 35.0464Z'
            fill='url(#paint8_linear_3794_18081)'
        />
        <path
            d='M11.9924 27.8296V34.4893C11.9924 34.5672 11.9718 34.6437 11.9328 34.7111C11.8938 34.7785 11.8378 34.8345 11.7703 34.8734C11.7028 34.9124 11.6263 34.9328 11.5484 34.9328C11.4705 34.9328 11.3939 34.9123 11.3265 34.8733L7.53496 32.6645L1.57234 29.1816C1.23554 28.9871 0.955711 28.7076 0.760915 28.371C0.56612 28.0344 0.463191 27.6525 0.462402 27.2636V13.1096C0.462691 12.9099 0.516883 12.7139 0.619246 12.5424C0.72161 12.3709 0.868376 12.2302 1.04404 12.1351L6.55152 9.14492C6.653 9.08989 6.76707 9.06219 6.88249 9.06453C6.99791 9.06687 7.11072 9.09918 7.20989 9.15828C7.30906 9.21737 7.39116 9.30124 7.44814 9.40164C7.50512 9.50204 7.53507 9.61552 7.53496 9.73097V23.3189C7.53536 23.7081 7.63812 24.0905 7.83293 24.4275C8.02775 24.7645 8.30777 25.0444 8.6449 25.239L11.4486 26.8707C11.6149 26.9693 11.7526 27.1096 11.848 27.2779C11.9434 27.4461 11.9932 27.6363 11.9924 27.8296Z'
            fill='url(#paint9_linear_3794_18081)'
        />
        <path
            d='M11.3265 34.8667L7.53496 32.6579L1.57234 29.1816C1.23554 28.9871 0.955711 28.7076 0.760915 28.371C0.56612 28.0344 0.463191 27.6525 0.462402 27.2636V13.1096C0.462691 12.9099 0.516883 12.7139 0.619246 12.5424C0.72161 12.3709 0.868376 12.2302 1.04404 12.1351L6.55152 9.14492C6.653 9.08989 6.76707 9.06219 6.88249 9.06453C6.99791 9.06687 7.11072 9.09918 7.20989 9.15828C7.30906 9.21737 7.39116 9.30124 7.44814 9.40164C7.50512 9.50204 7.53507 9.61552 7.53496 9.73097V23.3189C7.53496 23.3189 7.09539 27.803 11.3265 34.8667Z'
            fill='url(#paint10_radial_3794_18081)'
        />
        <path
            opacity='0.3'
            d='M15.5353 36.183C15.3292 36.183 15.1316 36.1011 14.9859 35.9554C14.8402 35.8097 14.7583 35.6121 14.7583 35.406V5.40213C14.7588 5.19292 14.8128 4.98731 14.9149 4.80474C15.0171 4.62217 15.1641 4.46868 15.3422 4.35879L20.8696 0.98235C20.9918 0.909301 21.1313 0.87022 21.2737 0.869141C21.4799 0.86914 21.6778 0.950924 21.8239 1.09657C21.9699 1.24221 22.0523 1.43983 22.0528 1.6461V32.0252C22.0525 32.2451 21.993 32.461 21.8805 32.65C21.768 32.8391 21.6067 32.9944 21.4135 33.0996L15.906 36.0875C15.7927 36.1506 15.665 36.1834 15.5353 36.183Z'
            fill='url(#paint11_linear_3794_18081)'
        />
        <path
            d='M15.8531 35.9901L21.3606 33.0021C21.5365 32.9069 21.6836 32.7658 21.7859 32.5939C21.8883 32.4219 21.9423 32.2255 21.9422 32.0254V1.64635C21.9423 1.52785 21.9108 1.41145 21.851 1.30918C21.7911 1.2069 21.7051 1.12245 21.6017 1.06454C21.4983 1.00662 21.3813 0.97734 21.2628 0.979718C21.1444 0.982096 21.0287 1.01605 20.9277 1.07806L15.4002 4.4545C15.238 4.55379 15.1039 4.69311 15.011 4.8591C14.9181 5.02509 14.8694 5.21217 14.8696 5.40238V35.4063C14.8699 35.5215 14.9001 35.6347 14.9573 35.7348C15.0144 35.8349 15.0965 35.9185 15.1956 35.9773C15.2947 36.0361 15.4074 36.0683 15.5226 36.0705C15.6379 36.0727 15.7518 36.045 15.8531 35.9901Z'
            fill='url(#paint12_linear_3794_18081)'
        />
        <path
            d='M11.9924 27.8296V34.4893C11.9924 34.5672 11.9718 34.6437 11.9328 34.7111C11.8938 34.7785 11.8378 34.8345 11.7703 34.8734C11.7028 34.9124 11.6263 34.9328 11.5484 34.9328C11.4705 34.9328 11.3939 34.9123 11.3265 34.8733L7.53496 32.6645L1.57234 29.1816C1.23554 28.9871 0.955711 28.7076 0.760915 28.371C0.56612 28.0344 0.463191 27.6525 0.462402 27.2636V13.1096C0.462691 12.9099 0.516883 12.7139 0.619246 12.5424C0.72161 12.3709 0.868376 12.2302 1.04404 12.1351L6.55152 9.14492C6.653 9.08989 6.76707 9.06219 6.88249 9.06453C6.99791 9.06687 7.11072 9.09918 7.20989 9.15828C7.30906 9.21737 7.39116 9.30124 7.44814 9.40164C7.50512 9.50204 7.53507 9.61552 7.53496 9.73097V23.3189C7.53536 23.7081 7.63812 24.0905 7.83293 24.4275C8.02775 24.7645 8.30777 25.0444 8.6449 25.239L11.4486 26.8707C11.6149 26.9693 11.7526 27.1096 11.848 27.2779C11.9434 27.4461 11.9932 27.6363 11.9924 27.8296Z'
            fill='url(#paint13_linear_3794_18081)'
        />
        <path
            opacity='0.3'
            d='M7.64621 23.3188C7.64621 23.3743 7.26217 27.8651 11.42 34.8089C11.433 34.8301 11.4382 34.8551 11.435 34.8797C11.4318 34.9044 11.4202 34.9272 11.4022 34.9443C11.3816 34.965 11.3537 34.977 11.3245 34.9776C11.305 34.9769 11.286 34.9716 11.269 34.9621L1.50154 29.2792C1.14948 29.0733 0.857338 28.779 0.654078 28.4255C0.450817 28.0719 0.343504 27.6713 0.342774 27.2635V13.1096C0.342531 12.8898 0.401843 12.674 0.514414 12.4852C0.626985 12.2964 0.788637 12.1417 0.982128 12.0374L6.48961 9.04719C6.60793 8.98221 6.74117 8.94926 6.87614 8.95163C7.0111 8.95399 7.14312 8.99158 7.25909 9.06067C7.37505 9.12976 7.47099 9.22794 7.53733 9.3455C7.60367 9.46307 7.63813 9.59592 7.63732 9.73091'
            fill='url(#paint14_linear_3794_18081)'
        />
        <path
            d='M11.3265 34.8667L7.53496 32.6579L1.57234 29.1816C1.23554 28.9871 0.955711 28.7076 0.760915 28.371C0.56612 28.0344 0.463191 27.6525 0.462402 27.2636V13.1096C0.462691 12.9099 0.516883 12.7139 0.619246 12.5424C0.72161 12.3709 0.868376 12.2302 1.04404 12.1351L6.55152 9.14492C6.653 9.08989 6.76707 9.06219 6.88249 9.06453C6.99791 9.06687 7.11072 9.09918 7.20989 9.15828C7.30906 9.21737 7.39116 9.30124 7.44814 9.40164C7.50512 9.50204 7.53507 9.61552 7.53496 9.73097V23.3189C7.53496 23.3189 7.09539 27.803 11.3265 34.8667Z'
            fill='url(#paint15_radial_3794_18081)'
        />
        <path
            d='M38.8666 5.30014V13.4271C38.8666 14.3151 39.0886 14.9944 39.5614 15.4694C40.0342 15.9445 40.6714 16.1753 41.5171 16.1753C42.3629 16.1753 43.0289 15.9533 43.4929 15.4694C43.9568 14.9855 44.1877 14.3217 44.1877 13.4271V5.30014H46.8382V13.4249C46.8693 14.4205 46.6168 15.4044 46.1101 16.2619C45.6422 17.0176 44.9673 17.6232 44.1655 18.0067C43.3198 18.4028 42.3954 18.6023 41.4616 18.5906C40.5406 18.6032 39.6291 18.4034 38.7978 18.0067C38.0106 17.6239 37.3541 17.0168 36.9109 16.2619C36.4223 15.3982 36.1812 14.4166 36.2139 13.4249V5.30014H38.8666Z'
            fill='white'
        />
        <path
            d='M60.622 18.4483H57.9826L52.02 9.43786V18.4483H49.3828V5.28668H52.02L57.9826 14.3194V5.28668H60.622V18.4483Z'
            fill='white'
        />
        <path
            d='M65.854 16.3618H70.1828V18.4485H63.2168V5.30014H65.854V16.3529V16.3618Z'
            fill='white'
        />
        <path d='M74.488 5.30014V18.4396H71.8618V5.30014H74.488Z' fill='white' />
        <path
            d='M91.4136 5.30014V18.4396H88.7742V9.89307L85.2624 18.4485H83.2645L79.7127 9.90195V18.4485H77.0732V5.30014H80.0656L84.239 15.0676L88.4124 5.30014H91.4136Z'
            fill='white'
        />
        <path d='M96.6463 5.30014V18.4396H94.0068V5.30014H96.6463Z' fill='white' />
        <path
            d='M108.172 5.30014V7.43123H104.673V18.4396H102.034V7.44011H98.5352V5.30014H108.172Z'
            fill='white'
        />
        <path
            d='M112.731 7.43997V10.7298H117.171V12.8165H112.731V16.2951H117.721V18.4372H110.105V5.28668H117.721V7.42886H112.731V7.43997Z'
            fill='white'
        />
        <path
            d='M128.342 6.11473C129.362 6.6272 130.208 7.43062 130.771 8.4234C131.337 9.48928 131.632 10.6775 131.632 11.8842C131.632 13.0908 131.337 14.2791 130.771 15.345C130.2 16.3262 129.356 17.1205 128.342 17.6315C127.21 18.1884 125.961 18.4648 124.7 18.4373H120.113V5.30003H124.706C125.965 5.28186 127.211 5.56099 128.342 6.11473ZM127.801 15.0808C128.551 14.3305 128.926 13.2701 128.926 11.8997C128.926 10.5293 128.551 9.4586 127.801 8.68757C127.05 7.91505 125.98 7.52879 124.6 7.52879H122.733V16.2063H124.6C125.98 16.2063 127.05 15.8311 127.801 15.0808Z'
            fill='white'
        />
        <path
            d='M37.0913 30.9019H40.1747V31.599H36.23V23.0169H37.0913V30.9019Z'
            fill='white'
        />
        <path
            d='M48.0722 23.725V26.9283H51.331V27.6476H48.0722V30.9041H51.6951V31.6234H47.2109V23.0169H51.6951V23.725H48.0722Z'
            fill='white'
        />
        <path
            d='M66.24 23.0169L62.9834 31.6101H62L58.7412 23.0169H59.6802L62.4972 30.6711L65.3342 23.0169H66.24Z'
            fill='white'
        />
        <path
            d='M74.1384 23.725V26.9283H77.395V27.6476H74.1384V30.9041H77.7613V31.6234H73.2749V23.0169H77.759V23.725H74.1362H74.1384Z'
            fill='white'
        />
        <path
            d='M89.3694 31.6101L87.2471 28.0205H85.6577V31.6101H84.7964V23.0169H87.3804C88.3416 23.0169 89.0697 23.2389 89.5558 23.7006C89.802 23.9317 89.9954 24.2131 90.123 24.5257C90.2506 24.8383 90.3093 25.1747 90.295 25.512C90.3099 26.088 90.123 26.651 89.7667 27.1037C89.3605 27.5696 88.7987 27.8717 88.1861 27.9539L90.395 31.599H89.3694V31.6101ZM85.6577 27.3235H87.3915C88.0574 27.3235 88.5724 27.1592 88.9054 26.8262C89.2273 26.4676 89.4072 26.0037 89.4113 25.5218C89.4154 25.0399 89.2434 24.573 88.9276 24.209C88.5946 23.9004 88.0863 23.745 87.3737 23.745H85.6511V27.3235H85.6577Z'
            fill='white'
        />
        <path
            d='M103.008 29.5653H99.0989L98.3463 31.6098H97.4429L100.58 23.1276H101.55L104.675 31.6098H103.77L103.008 29.5653ZM102.755 28.8594L101.052 24.2087L99.3519 28.8594H102.755Z'
            fill='white'
        />
        <path
            d='M118.858 25.5233C118.623 24.9769 118.23 24.513 117.73 24.1914C117.197 23.8616 116.581 23.6928 115.954 23.7052C115.351 23.695 114.755 23.8485 114.232 24.1492C113.723 24.4512 113.306 24.8874 113.029 25.4101C112.738 26.001 112.587 26.6507 112.587 27.3092C112.587 27.9677 112.738 28.6174 113.029 29.2083C113.302 29.7362 113.719 30.1763 114.232 30.4781C114.755 30.7796 115.35 30.933 115.954 30.9221C116.516 30.9299 117.071 30.7972 117.568 30.5358C118.046 30.2747 118.445 29.8917 118.727 29.4259C119.024 28.9134 119.195 28.3372 119.224 27.7454H115.612V27.055H120.13V27.6855C120.098 28.4074 119.885 29.1097 119.511 29.7278C119.143 30.3422 118.619 30.8487 117.993 31.196C117.366 31.5433 116.659 31.7191 115.943 31.7057C115.184 31.7141 114.437 31.5194 113.779 31.1418C113.135 30.7732 112.604 30.236 112.243 29.5879C111.874 28.8901 111.681 28.1129 111.681 27.3236C111.681 26.5344 111.874 25.7571 112.243 25.0594C112.601 24.4092 113.133 23.8713 113.779 23.5054C114.483 23.1158 115.278 22.9216 116.082 22.9431C116.886 22.9645 117.67 23.2009 118.352 23.6275C119.044 24.0911 119.57 24.764 119.852 25.5477H118.86L118.858 25.5233Z'
            fill='white'
        />
        <path
            d='M128.035 23.725V26.9283H131.293V27.6476H128.035V30.9041H131.657V31.6234H127.173V23.0169H131.657V23.725H128.035Z'
            fill='white'
        />
        <defs>
            <linearGradient
                id='paint0_linear_3794_18081'
                x1='18.5125'
                y1='41.4332'
                x2='18.3149'
                y2='-0.784417'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint1_linear_3794_18081'
                x1='3.41706'
                y1='22.1379'
                x2='17.4977'
                y2='21.7894'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='paint2_radial_3794_18081'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(5.89444 21.9647) scale(14.6734 14.6734)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
            <linearGradient
                id='paint3_linear_3794_18081'
                x1='18.5125'
                y1='41.4332'
                x2='18.3149'
                y2='-0.784417'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint4_linear_3794_18081'
                x1='3.41706'
                y1='22.1379'
                x2='17.4977'
                y2='21.7894'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='paint5_radial_3794_18081'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(5.89444 21.9647) scale(14.6734 14.6734)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
            <linearGradient
                id='paint6_linear_3794_18081'
                x1='18.5121'
                y1='41.5773'
                x2='18.3146'
                y2='-0.906762'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint7_linear_3794_18081'
                x1='18.5125'
                y1='41.4332'
                x2='18.3149'
                y2='-0.784417'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint8_linear_3794_18081'
                x1='3.36327'
                y1='22.14'
                x2='17.717'
                y2='21.7849'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint9_linear_3794_18081'
                x1='3.41706'
                y1='22.1379'
                x2='17.4977'
                y2='21.7894'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='paint10_radial_3794_18081'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(5.89444 21.9647) scale(14.6734 14.6734)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
            <linearGradient
                id='paint11_linear_3794_18081'
                x1='18.5121'
                y1='41.5773'
                x2='18.3146'
                y2='-0.906762'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint12_linear_3794_18081'
                x1='18.5125'
                y1='41.4332'
                x2='18.3149'
                y2='-0.784417'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint13_linear_3794_18081'
                x1='3.41706'
                y1='22.1379'
                x2='17.4977'
                y2='21.7894'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint14_linear_3794_18081'
                x1='5.96352'
                y1='37.3218'
                x2='5.62166'
                y2='6.2235'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='paint15_radial_3794_18081'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(9.26422 21.8759) scale(14.6734 14.6734)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
        </defs>
    </svg>
);

export default FooterLogo;
